import { render } from "./DesignCV.vue?vue&type=template&id=4e46d33b&scoped=true"
import script from "./DesignCV.vue?vue&type=script&lang=js"
export * from "./DesignCV.vue?vue&type=script&lang=js"

import "./DesignCV.vue?vue&type=style&index=0&id=4e46d33b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e46d33b"]])

export default __exports__